import React from 'react';
import { FaTimes, FaEnvelope, FaCode, FaRoute, FaDatabase } from 'react-icons/fa';

const ReportTypeChooser = ({ isOpen, onClose, onSelectBasic, onSelectAdvanced }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-gray-900/60 dark:bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-surface rounded-xl shadow-2xl max-w-2xl w-full mx-4">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Create Email Report</h2>
            <p className="text-sm text-gray-500 mt-1">
              Choose the type of report you want to create
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-2">
            <FaTimes />
          </button>
        </div>

        {/* Cards */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Quick Report Card */}
          <button
            onClick={onSelectBasic}
            className="text-left p-6 border-2 border-gray-200 rounded-xl hover:border-primary-400 hover:bg-primary-50/50 transition-all group"
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <FaRoute className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Quick Report</h3>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Standard route summary with predefined template. Select route groupings, date range,
              and recipients.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
                <FaEnvelope className="w-3 h-3 mr-1" />
                Fixed template
              </span>
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
                Daily / Weekly / Monthly
              </span>
            </div>
          </button>

          {/* Custom Report Card */}
          <button
            onClick={onSelectAdvanced}
            className="text-left p-6 border-2 border-gray-200 rounded-xl hover:border-primary-400 hover:bg-primary-50/50 transition-all group"
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <FaCode className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Custom Report</h3>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              SQL-powered with custom HTML template and flexible scheduling. Full control over data
              and formatting.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-600">
                <FaDatabase className="w-3 h-3 mr-1" />
                Custom SQL
              </span>
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-600">
                <FaCode className="w-3 h-3 mr-1" />
                Handlebars template
              </span>
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-600">
                Cron / Interval / One-time
              </span>
            </div>
          </button>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportTypeChooser;
